// @flow

import {combineReducers} from 'redux';
import {GET_SETTINGS_SUCCESS, UPDATE_SETTINGS, SET_CURRENT_VIEW, POST_SESSIONS_PRIVACY_SUCCESS}
from '../actions/constants';
import {PAGE_NAMES} from '../pages';

type NamedAction = {
    type: string,
    name: string
}

type SettingsAction = NamedAction & {
    settings: {}
}

const privacy = (state: ?PrivacySettings = null, action: SettingsAction): ?PrivacySettings => {
    if (action.type === GET_SETTINGS_SUCCESS && action.name === PAGE_NAMES.PRIVACY) {
        return Object.assign({}, action.settings);
    }
    if (action.type === UPDATE_SETTINGS && action.name === PAGE_NAMES.PRIVACY) {
        return Object.assign({}, action.settings);
    }
    return state;
};

const notifications = (state = null, action) => {
    return state;
};

const current = (state: ?string = null, action: NamedAction): ?string => {
    if (action.type === SET_CURRENT_VIEW) {
        return action.name;
    }
    return state;
};

const isInvalidateAllTrainingShareLinksSuccess = (state, action) => {
    if (action.type === POST_SESSIONS_PRIVACY_SUCCESS) {
        return true;
    }
    return false;
};

export default combineReducers({
    privacy,
    notifications,
    current,
    isInvalidateAllTrainingShareLinksSuccess
});



// WEBPACK FOOTER //
// ./src/UserSettings/reducers/settings.js